import { apiGet, apiPatch } from './client';
import type { CategoryMap, CategoryMapBatchRequest, CategoryMapKey } from '../types/CategoryMap';

function withIdKey(rows: Omit<CategoryMap, 'idKey'>[]): CategoryMap[] {
  return rows.map((r) => ({ ...r, idKey: `${r.assetTypeId}|${r.balanceTypeId}` }));
}
function stripIdKey(rows: CategoryMap[]): Omit<CategoryMap, 'idKey'>[] {
  return rows.map(({ idKey, ...rest }) => rest);
}
function parseIdKey(idKey: string): CategoryMapKey {
  const [a, b] = idKey.split('|');
  return { assetTypeId: Number(a), balanceTypeId: Number(b) };
}

export async function getCategoryMap(): Promise<CategoryMap[]> {
  const rows = await apiGet<Omit<CategoryMap, 'idKey'>[]>('/api/category-map');
  return withIdKey(rows);
}

export async function saveCategoryMapBatch(
  added: CategoryMap[],
  modified: CategoryMap[],
  deletedIdKeys: string[],
): Promise<CategoryMap[]> {
  const body: CategoryMapBatchRequest = {
    added: stripIdKey(added),
    modified: stripIdKey(modified),
    deleted: deletedIdKeys.map(parseIdKey),
  };
  const fresh = await apiPatch<CategoryMapBatchRequest, Omit<CategoryMap, 'idKey'>[]>('/api/category-map/batch', body);
  return withIdKey(fresh);
}
